export default __webpack_public_path__ + "static/media/ReplaceDummyCode.83f6cdd3.png";